import { gsq } from './gsq';


export default {
  directives: {
    gsq
  }
};
